<template>
  <el-button class="xy-button-v2" v-bind="$attrs" :size="size" v-on="$listeners">
    <slot />
  </el-button>
</template>

<script>
export default {
  name: 'XYButtonV2',
  props: {
    size: {
      type: String,
      default: 'medium'
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/theme.scss';

.xy-button-v2 {
  min-width: 152px;
  height: 44px;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  font-weight: 400;
  font-size: 17px;
  background: #fff;
  color: #333;

  &.is-round {
    border-radius: 20px;
  }

  &.el-button + .el-button {
    margin-left: 15px;
  }

  &.el-button:hover,
  .el-button:focus {
    background: #f6f6f6;
    color: #333;
  }

  &.el-button--primary {
    @include gradient('primary');
    border: none;
    color: #fff;
  }

  &.el-button--primary:hover,
  .el-button--primary:focus {
    background: $primary-deep;
    color: #fff;
  }

  &.el-button--primary.is-disabled,
  &.el-button--primary.is-disabled:hover,
  &.el-button--primary.is-disabled:focus,
  &.el-button--primary.is-disabled:active {
    background: $primary-percent-30;
    color: #fff;
  }

  &.el-button--danger {
    background-color: $danger;
    border: none;
    color: #fff;
  }

  &.el-button--danger:hover,
  .el-button--danger:focus {
    background-color: $danger-deep;
    color: #fff;
  }

  &.el-button--danger.is-disabled,
  &.el-button--danger.is-disabled:hover,
  &.el-button--danger.is-disabled:focus,
  &.el-button--danger.is-disabled:active {
    background: $danger-percent-30;
    color: #fff;
  }

  &.el-button--info {
    background-color: #f6f6f6;
    border: none;
  }

  &.el-button--info:hover,
  .el-button--info:focus {
    background-color: #f1f1f1;
  }

  &.el-button--small {
    min-width: 70px;
    height: 30px;
    padding: 9px 15px;
    font-size: 12px;
    border-radius: 3px;
  }
}
</style>
